import { apiClient } from '@/services/ApiClient.js'

export default {
  startExportDocumentProcess(form) {
    let rawData = {
      with_invoice_numbers: form.with_invoice_numbers,
      type: form.type
    }

    let formData = new FormData()
    formData.append('file', form.file)
    formData.append('data', JSON.stringify(rawData))

    return apiClient
      .postForm('/orders/actions/export-documents', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
